import { Article } from '../../types'

export const MOCK_BUSINESS_ARTICLES: Article[] = [
  {
    source: {
      name: 'CNBC',
    },
    title:
      'Dow futures gain nearly 200 points after in-line inflation report, bank stock rebound: Live updates - CNBC',
    author: 'Alex Harring, Sarah Min',
    url: 'https://www.cnbc.com/2023/03/13/stock-market-today-live-updates.html',
    urlToImage:
      'https://image.cnbcfm.com/api/v1/image/107138894-Traders-TF-Photo-202201021-ACJ-086-PRESS-4.jpg?v=1678745827&w=1920&h=1080',
    publishedAt: '2023-03-14T12:43:00Z',
  },
  {
    source: {
      name: 'CNN',
    },
    title: 'The latest on the Silicon Valley Bank collapse: Live updates - CNN',
    author:
      'By <a href="/profiles/aditi-sandal">Aditi Sangal</a>, <a href="/profiles/nicole-goodkind">Nicole Goodkind</a> and Lucy Bayly, CNN',
    url: 'https://www.cnn.com/business/live-news/silicon-valley-bank-collapse-updates-03-14-23/index.html',
    urlToImage:
      'https://dynaimage.cdn.cnn.com/cnn/digital-images/org/ee6ac24e-1fce-475c-a1de-edfff7206928.jpg',
    publishedAt: '2023-03-14T12:32:46Z',
  },
  {
    source: {
      name: 'CNBC',
    },
    title: 'CPI inflation February 2023: - CNBC',
    author: 'Jeff Cox',
    url: 'https://www.cnbc.com/2023/03/14/cpi-inflation-february-2023-.html',
    urlToImage:
      'https://image.cnbcfm.com/api/v1/image/107195792-16765636862023-02-16t151931z_117200947_rc2ecz937tqu_rtrmadp_0_usa-eggs-antitrust.jpeg?v=1678797082&w=1920&h=1080',
    publishedAt: '2023-03-14T12:31:22Z',
  },
  {
    source: {
      name: 'CNBC',
    },
    title:
      'Why you should buy everything with credit cards — provided you meet 1 condition - CNBC',
    author: 'Emily Lorsch',
    url: 'https://www.cnbc.com/2023/03/14/why-you-should-buy-everything-with-credit-cards.html',
    urlToImage:
      'https://image.cnbcfm.com/api/v1/image/107068212-1653661462402-gettyimages-1306582149-giof11197.jpeg?v=1678795201&w=1920&h=1080',
    publishedAt: '2023-03-14T12:00:01Z',
  },
  {
    source: {
      name: 'CNBC',
    },
    title: '5 things to know before the stock market opens Tuesday - CNBC',
    author: 'Mike Calia',
    url: 'https://www.cnbc.com/2023/03/14/5-things-to-know-before-the-stock-market-opens-tuesday-march-14.html',
    urlToImage:
      'https://image.cnbcfm.com/api/v1/image/107205160-16782931822023-03-08t162725z_1293444268_rc2rpz9ju9l3_rtrmadp_0_usa-fed-powell.jpeg?v=1678791992&w=1920&h=1080',
    publishedAt: '2023-03-14T11:06:32Z',
  },
  {
    source: {
      name: 'CNBC',
    },
    title:
      'First Republic shares jump 40% as regional banks try to rebound from Monday’s sell-off - CNBC',
    author: 'Jesse Pound, Fred Imbert',
    url: 'https://www.cnbc.com/2023/03/14/first-republic-shares-jump-as-regional-banks-try-to-rebound-from-mondays-selloff.html',
    urlToImage:
      'https://image.cnbcfm.com/api/v1/image/107207471-1678710077938-gettyimages-1247997034-FIRST_REPUBLIC_BANK.jpeg?v=1678791818&w=1920&h=1080',
    publishedAt: '2023-03-14T11:03:38Z',
  },
  {
    source: {
      name: 'CNN',
    },
    title:
      "Credit Suisse finds 'material weakness' in its financial reporting, scraps exec bonuses - CNN",
    author: 'Hanna Ziady',
    url: 'https://www.cnn.com/2023/03/14/investing/credit-suisse-financial-reporting-weakness/index.html',
    urlToImage:
      'https://media.cnn.com/api/v1/images/stellar/prod/230314090127-credit-suisse-file-111722.jpg?c=16x9&q=w_800,c_fill',
    publishedAt: '2023-03-14T10:49:00Z',
  },
  {
    source: {
      name: 'YouTube',
    },
    title:
      'Watch live: Joint committee hears evidence on the forced installation of pre-payment meters in homes - Sky News',
    author: null,
    url: 'https://www.youtube.com/watch?v=_u2TYeFlkqo',
    urlToImage: 'https://i.ytimg.com/vi/_u2TYeFlkqo/maxresdefault.jpg',
    publishedAt: '2023-03-14T10:13:12Z',
  },
  {
    source: {
      name: 'Bloomberg',
    },
    title:
      'Global Financial Stocks Lose $465 Billion on SVB Collapse, Contagion Fears - Bloomberg',
    author: 'Kurt Schussler',
    url: 'https://www.bloomberg.com/news/articles/2023-03-14/global-financial-stocks-lose-465-billion-on-svb-impact-worry',
    urlToImage:
      'https://assets.bwbx.io/images/users/iqjWHBFdfxIU/iPMzX7z8eXaQ/v0/1200x800.jpg',
    publishedAt: '2023-03-14T09:38:46Z',
  },
  {
    source: {
      name: 'USA Today',
    },
    title:
      'Canceling meetings is in, crowded calendars are out. RIP meetings? - USA TODAY',
    author: 'Jessica Guynn, USA TODAY',
    url: 'https://www.usatoday.com/story/money/2023/03/14/companies-cancel-meetings-to-save-time/11436741002/',
    urlToImage:
      'https://www.gannett-cdn.com/presto/2023/03/09/USAT/bfc7a1b5-da96-41f9-b521-08d56d046924-USATSI_15704744.jpg?auto=webp&crop=3450,1941,x0,y242&format=pjpg&width=1200',
    publishedAt: '2023-03-14T09:00:49Z',
  },
  {
    source: {
      name: 'Cointelegraph',
    },
    title:
      'Bitcoin market cap flips tech giant Meta, widens gap on Visa - Cointelegraph',
    author: 'Ciaran Lyons',
    url: 'https://cointelegraph.com/news/bitcoin-market-cap-flips-tech-giant-meta-widens-gap-on-visa',
    urlToImage:
      'https://images.cointelegraph.com/cdn-cgi/image/format=auto,onerror=redirect,quality=90,width=1200/https://s3.cointelegraph.com/uploads/2023-03/81a63989-e226-42be-8a47-baa6990f179f.jpg',
    publishedAt: '2023-03-14T08:05:27Z',
  },
  {
    source: {
      name: 'CNN',
    },
    title:
      'Masatoshi Ito, Japanese billionaire behind the rise of 7-Eleven, dies at 98 - CNN',
    author: 'Kathleen Magramo, Moeri Karasawa',
    url: 'https://www.cnn.com/2023/03/14/business/japan-billionaire-7-eleven-masatoshi-ito-death-intl-hnk/index.html',
    urlToImage:
      'https://media.cnn.com/api/v1/images/stellar/prod/230313235836-02-masatoshi-ito-file-031323.jpg?c=16x9&q=w_800,c_fill',
    publishedAt: '2023-03-14T08:01:00Z',
  },
  {
    source: {
      name: "Barron's",
    },
    title:
      "Why Regions Financial, Fifth Third Bank, and M&T Bank Stock Are Worth a Look - Barron's",
    author: 'Al Root',
    url: 'https://www.barrons.com/articles/regions-financial-mt-fifth-third-bank-stock-price-573d3aac',
    urlToImage: 'https://images.barrons.com/im-742556/social',
    publishedAt: '2023-03-14T08:00:00Z',
  },
  {
    source: {
      name: 'CNBC',
    },
    title:
      'SVB fallout unlikely to affect fundraising for Southeast Asia startups, venture capitalists say - CNBC',
    author: 'Sheila Chiang',
    url: 'https://www.cnbc.com/2023/03/14/svb-collapse-unlikely-to-hit-fundraising-for-southeast-asia-startups-vcs.html',
    urlToImage:
      'https://image.cnbcfm.com/api/v1/image/107208061-1678768577925-gettyimages-1248159247-AA_13032023_1108254.jpeg?v=1678776896&w=1920&h=1080',
    publishedAt: '2023-03-14T06:42:38Z',
  },
  {
    source: {
      name: 'CNBC',
    },
    title:
      "The U.S. stock market keeps beating Europe in new listings. And it's no fluke - CNBC",
    author: 'Silvia Amaro',
    url: 'https://www.cnbc.com/2023/03/14/us-stock-market-beats-europe-in-new-listings.html',
    urlToImage:
      'https://image.cnbcfm.com/api/v1/image/107206431-1678446162996-gettyimages-1391107271-img_4801_4fedc280-9211-4dd4-8ed2-0fe6594c9d91.jpeg?v=1678775814&w=1920&h=1080',
    publishedAt: '2023-03-14T06:36:54Z',
  },
  {
    source: {
      name: 'Daily Mail',
    },
    title:
      'Silicon Valley Bank appoint new CEO as staff take aim at the previous bank chief - Daily Mail',
    author: 'Harriet Alexander',
    url: 'https://www.dailymail.co.uk/news/article-11856847/Silicon-Valley-Bank-appoint-new-CEO-staff-aim-previous-bank-chief.html',
    urlToImage:
      'https://i.dailymail.co.uk/1s/2023/03/14/05/68674821-0-image-a-6_1678771554586.jpg',
    publishedAt: '2023-03-14T05:41:08Z',
  },
  {
    source: {
      name: 'The Guardian',
    },
    title:
      'Silicon Valley Bank: parent company, CEO and CFO sued amid market turmoil - The Guardian',
    author: 'Guardian staff reporter',
    url: 'https://www.theguardian.com/business/2023/mar/14/silicon-valley-bank-lawsuit-fraud-shareholders',
    urlToImage:
      'https://i.guim.co.uk/img/media/21ffee6606f9bed849bbd3eb032f68172a456426/0_24_4000_2400/master/4000.jpg?width=1200&height=630&quality=85&auto=format&fit=crop&overlay-align=bottom%2Cleft&overlay-width=100p&overlay-base64=L2ltZy9zdGF0aWMvb3ZlcmxheXMvdGctZGVmYXVsdC5wbmc&enable=upscale&s=f39eb54f3d29fed75b17585778f2c887',
    publishedAt: '2023-03-14T05:00:00Z',
  },
  {
    source: {
      name: 'BBC News',
    },
    title: 'US court rules Uber and Lyft workers are contractors - BBC',
    author: 'https://www.facebook.com/bbcnews',
    url: 'https://www.bbc.com/news/business-64947695',
    urlToImage:
      'https://ichef.bbci.co.uk/news/1024/branded_news/16BF9/production/_128977139_ubereats.jpg',
    publishedAt: '2023-03-14T03:48:05Z',
  },
  {
    source: {
      name: 'Reuters',
    },
    title:
      "Moody's downgrades Signature Bank to junk, places six U.S. banks under review - Reuters",
    author: null,
    url: 'https://www.reuters.com/business/finance/moodys-downgrades-signature-bank-junk-places-six-us-banks-under-review-2023-03-14/',
    urlToImage:
      'https://www.reuters.com/resizer/z1FdAzC5tkwlQtY8UAuktpFaaPg=/1200x628/smart/filters:quality(80)/cloudfront-us-east-2.images.arcpublishing.com/reuters/IOPW5CIW6BMDJPUOWT24N74Y4Q.jpg',
    publishedAt: '2023-03-14T03:09:00Z',
  },
  {
    source: {
      name: 'Yahoo Entertainment',
    },
    title:
      'Bitcoin jumps above US$24,000, leading crypto gains as U.S. acts to backstop banks - Yahoo Finance',
    author: 'Tom Zuo',
    url: 'https://finance.yahoo.com/news/bitcoin-jumps-above-us-24-025629819.html',
    urlToImage:
      'https://s.yimg.com/ny/api/res/1.2/z.GvTKS2GWcrX3pwlBIVEw--/YXBwaWQ9aGlnaGxhbmRlcjt3PTEyMDA7aD04MDE-/https://media.zenfs.com/en/forkast_news_articles_672/bd2072e580d4a231397ba800051c8b6b',
    publishedAt: '2023-03-14T02:56:00Z',
  },
  {
    source: {
      name: 'YouTube',
    },
    title:
      'BIZARRE Right-wing Explanations For The Silicon Valley Bank Collapse - The Young Turks',
    author: null,
    url: 'https://www.youtube.com/watch?v=wcw6r9EmcBc',
    urlToImage: 'https://i.ytimg.com/vi/wcw6r9EmcBc/maxresdefault.jpg',
    publishedAt: '2023-03-14T02:45:01Z',
  },
  {
    source: {
      name: 'YouTube',
    },
    title:
      'How FDIC Insurance Protects Your Money | NBC Washington - NBC4 Washington',
    author: null,
    url: 'https://www.youtube.com/watch?v=nnBTrCBvHoM',
    urlToImage:
      'https://i.ytimg.com/vi/nnBTrCBvHoM/maxresdefault.jpg?sqp=-oaymwEmCIAKENAF8quKqQMa8AEB-AH-CYAC0AWKAgwIABABGDEgZShZMA8=&rs=AOn4CLDDT3ZYHDoP6-6fdWTAQiH3tkvZhA',
    publishedAt: '2023-03-14T00:06:35Z',
  },
  {
    source: {
      name: 'YouTube',
    },
    title: 'Markets dodged a bullet today, says Cramer - CNBC Television',
    author: null,
    url: 'https://www.youtube.com/watch?v=xBasFH1t1qM',
    urlToImage: 'https://i.ytimg.com/vi/xBasFH1t1qM/maxresdefault.jpg',
    publishedAt: '2023-03-14T00:01:03Z',
  },
  {
    source: {
      name: "Barron's",
    },
    title:
      "As Charles Schwab Stock Tumbles, Executives Reassure Investors - Barron's",
    author: 'Andrew Welsch',
    url: 'https://www.barrons.com/articles/charles-schwab-stock-price-bank-d9b68ef3',
    urlToImage: 'https://images.barrons.com/im-741911/social',
    publishedAt: '2023-03-13T23:16:00Z',
  },
  {
    source: {
      name: 'Engadget',
    },
    title: 'Meta is killing NFT support on Facebook and Instagram - Engadget',
    author: 'https://www.engadget.com/about/editors/karissa-bell',
    url: 'https://www.engadget.com/meta-is-killing-nft-support-on-facebook-and-instagram-225517412.html',
    urlToImage:
      'https://s.yimg.com/uu/api/res/1.2/_cOIRZQ6FbxVFlpJ6ga_hA--~B/Zmk9ZmlsbDtoPTYzMDtweW9mZj0wO3c9MTIwMDthcHBpZD15dGFjaHlvbg--/https://media-mbst-pub-ue1.s3.amazonaws.com/creatr-uploaded-images/2022-11/dd4a96d0-5aef-11ed-aff2-5f018b78aa7f.cf.jpg',
    publishedAt: '2023-03-13T22:55:53Z',
  },
]
